import { Component, OnInit } from '@angular/core';
import { PopupDialog } from '@app/Common/popup/popup.dialog';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TenantService } from '../../../../Services/tenant.service';
import { Package, GroupedPackage, Release } from "../Models";
import { ModuleService } from '../Services/module.service';
import { PackageService } from '../Services/package.service';
import { ReleaseService } from '../Services/release.service';
import { PermissionService } from '@app/Services/permission.service';
import { Permissions } from '@app/Models/Permissions';
import { MatFormField, MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { AsyncPipe, DatePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { SpinnerComponent } from '../../../../Common/spinner/spinner.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { TranslationPipe } from '../../../../Services/translation.pipe';

@Component({
    selector: 'my-package',
    templateUrl: './package.component.html',
    styleUrls: ['./package.component.css'],
    imports: [MatFormField, MatInput, FormsModule, MatButton, MatIcon, SpinnerComponent, MatCheckbox, MatPaginator, AsyncPipe, DatePipe, TranslationPipe]
})
export class PackageComponent implements OnInit {
    loading: boolean = true;
    release: Release = new Release();
    packageGroups: GroupedPackage[] = [];
    allPackages: Package[] = [];
    selectedPackages: Package[] = [];
    releaseNotes: string;
    totalCount: number = 0;
    currentPage: number = 1;
    pageSize: number = 10;
    readonly permissions = Permissions;
    hideResetButton: boolean = false;

    constructor(
        private activatedRoute: ActivatedRoute,
        private tenantService: TenantService,
        public packageService: PackageService,
        private releaseService: ReleaseService,
        private router: Router,
        public dialog: MatDialog,
        private moduleService: ModuleService,
        public permissionService: PermissionService
    ) {
    }

    ngOnInit(): void {
        this.loadPackages();

        this.hideResetButton = this.activatedRoute.snapshot.url.some(
            (url) => url.path.indexOf('from-create-package') !== -1
        );
    }

    ngDoCheck() {
    }

    loadPackages(): void {
        this.loading = true;
        this.packageService.getPackages(this.tenantService.selectedTenant, this.currentPage, this.pageSize)
            .then(result => {
                this.packageGroups = result.Packages;
                this.totalCount = result.TotalCount;
                this.allPackages = this.packageGroups.map(g => g.MajorPackage).concat(this.packageGroups.flatMap(g => g.MinorPackages));
                this.loading = false;
            });
    }

    onPageChange(event: PageEvent): void {
        this.currentPage = event.pageIndex + 1;
        this.pageSize = event.pageSize;
        this.loadPackages();
    }

    onSelectedPackageChange(): void {
        this.selectedPackages = this.allPackages.filter(x => x.IsChecked == true);
    }

    get hasPackagesForRelease(): boolean {
        return this.selectedPackages.length > 0;
    }

    createRelease(): void {
        console.log("Create Release");

        if (this.hasPackagesForRelease == false) {
            return;
        }

        this.release.ReleaseNotes = this.releaseNotes;
        this.release.Packages = this.selectedPackages;
        this.releaseService.createRelease(this.tenantService.selectedTenant, this.release).then((res) => {
            this.router.navigate(["../releases"], { relativeTo: this.activatedRoute });
        });
    }

    resetToSpecificVersion(moduleId: string, version: number) {
        const dialogRef = this.dialog.open(PopupDialog);
        dialogRef.componentInstance.DialogTitle = 'Reset Module - ' + moduleId;
        dialogRef.componentInstance.DialogDescription = 'Are you sure you want to reset this module and lose any unpublished changes?';
        dialogRef.componentInstance.DialogConfirmButtonText = 'Yes';
        dialogRef.componentInstance.DialogCancelButtonText = 'No';

        dialogRef.afterClosed().subscribe((res) => {
            if (!res.Result) {
                return;
            }
            this.moduleService.resetModuleContent(this.tenantService.selectedTenant, moduleId, version)
                .then(() => {
                    this.router.navigate(['../modules', moduleId, version], { relativeTo: this.activatedRoute });
                });
        });
    }
}
